<template>
  <a-drawer width="45vw" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-form-model :model="form" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item label="主播名称">
        <a-input v-model="form.nickName" />
      </a-form-model-item>
      <a-form-model-item label="主播头像">
        <OssUploadSingle v-if="open" v-model="form.avatar" type="img" :maxSize="300"></OssUploadSingle>
      </a-form-model-item>

      <a-form-model-item label="等级">
        <a-select v-model="form.anchorsLevelId" placeholder="请选择主播等级">
          <a-select-option v-for="item in levelList" :value="item.id">{{ item.level }} </a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
        <a-button type="primary" @click="onSubmit"> 保存 </a-button>
        <a-button style="margin-left: 10px"> 取消 </a-button>
      </a-form-model-item>
    </a-form-model>
  </a-drawer>
</template>
<script>
import { listAnchorsLevel } from '@/api/trade/anchorsLevel'
import OssUploadSingle from '@/components/OssUploadSingle/index.vue'
import { settingLevel } from '@/api/biz/user'
export default {
  data() {
    return {
      open: false,
      levelList: [],
      form: {
        id: undefined,
        nickName: '',
        avatar: undefined,
        anchorsLevelId: undefined,
      },
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
    }
  },
  components: { OssUploadSingle },
  methods: {
    onClose() {
      this.open = false
      this.$emit('close')
    },
    levelListData() {
      listAnchorsLevel().then((res) => {
        this.levelList = res.data
        console.log(this.levelList)
      })
    },
    showModal(record) {
      this.restForm()
      this.open = true
      this.levelListData()
      this.form = {
        id: record.id,
        nickName: record.nickName,
        avatar: record.avatar,
        anchorsLevelId: record.anchorsLevelId,
      }
    },
    restForm() {
      this.form = {
        id: undefined,
        nickName: '',
        avatar: undefined,
        anchorsLevelId: undefined,
      }
    },
    onSubmit() {
      let data = {
        userId: this.form.id,
        anchorsLevelId: this.form.anchorsLevelId,
      }
      settingLevel(data).then((res) => {
        this.$message.success('保存成功')
        this.restForm()
        this.open = false
        this.$emit('success')
      })
    },
  },
}
</script>
